import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
    const [isPlaying, setIsPlaying] = useState(false);
    const [trackIndex, setTrackIndex] = useState(0);

    const tracks = [
        { name: 'TRK 1', src: '/8bit-music.mp3' },
        { name: 'TRK 2', src: '/8bit-music-2.mp3' },
    ];

    const toggleMusic = () => {
        const audio = document.getElementById('bg-music');
        if (audio) {
            if (isPlaying) {
                audio.pause();
            } else {
                audio.play().catch(e => console.log('Audio play failed:', e));
            }
            setIsPlaying(!isPlaying);
        }
    };

    const toggleTheme = () => {
        document.documentElement.classList.toggle('theme-amber');
    };

    const nextTrack = () => {
        const nextIndex = (trackIndex + 1) % tracks.length;
        setTrackIndex(nextIndex);
        const audio = document.getElementById('bg-music');
        if (audio) {
            audio.src = tracks[nextIndex].src;
            if (isPlaying) {
                audio.play().catch(e => console.log('Audio play failed:', e));
            }
        }
    };

    return (
        <header className="fixed top-0 w-full bg-acid z-50">
            <nav className="max-w-3xl mx-auto px-4 flex justify-between items-center h-20 md:h-24">
                <div className="text-sm md:text-2xl font-bold text-black tracking-widest flex items-center">
                    <Link to="/" className="mt-2 md:mt-4 hover:bg-black hover:text-acid p-2 transition-none border-2 border-transparent border-dashed hover:border-black flex items-center">
                        <svg viewBox="0 0 100 80" className="h-14 md:h-20 w-auto" fill="currentColor">
                            <rect x="8" y="0" width="84" height="4" />
                            <rect x="8" y="56" width="24" height="4" />
                            <rect x="56" y="56" width="36" height="4" />
                            <rect x="0" y="8" width="4" height="44" />
                            <rect x="96" y="8" width="4" height="44" />
                            <rect x="4" y="4" width="4" height="4" />
                            <rect x="92" y="4" width="4" height="4" />
                            <rect x="4" y="52" width="4" height="4" />
                            <rect x="92" y="52" width="4" height="4" />
                            <rect x="32" y="60" width="4" height="20" />
                            <rect x="36" y="76" width="4" height="4" />
                            <rect x="40" y="72" width="4" height="4" />
                            <rect x="44" y="68" width="4" height="4" />
                            <rect x="48" y="64" width="4" height="4" />
                            <rect x="52" y="60" width="4" height="4" />
                            <text x="50" y="28" fontFamily="'Press Start 2P', monospace" fontSize="13" textAnchor="middle">LEVEL</text>
                            <text x="50" y="48" fontFamily="'Press Start 2P', monospace" fontSize="13" textAnchor="middle">UP!</text>
                        </svg>
                    </Link>
                </div>
                <div className="text-[10px] md:text-sm font-bold text-black flex items-center space-x-2 md:space-x-4 uppercase">
                    <div className="flex space-x-1 md:space-x-2">
                        <button
                            onClick={toggleTheme}
                            className="border-2 border-black px-2 py-1 shadow-[2px_2px_0_0_#000] hover:bg-black hover:text-acid active:translate-y-1 active:translate-x-1 active:shadow-none transition-none focus:outline-none"
                            title="Toggle CRT Color"
                        >
                            COLOR
                        </button>
                        <button
                            onClick={toggleMusic}
                            className="flex items-center border-2 border-black px-2 py-1 shadow-[2px_2px_0_0_#000] hover:bg-black hover:text-acid active:translate-y-1 active:translate-x-1 active:shadow-none transition-none focus:outline-none"
                            title={isPlaying ? "Pause Music" : "Play Music"}
                        >
                            <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor" className="inline-block md:mr-2">
                                <path d="M4 7h4l4-4v14l-4-4H4V7z" />
                                {isPlaying ? (
                                    <>
                                        <rect x="14" y="7" width="2" height="6" />
                                        <rect x="18" y="4" width="2" height="12" />
                                    </>
                                ) : (
                                    <path d="M14 7l4 6m0-6l-4 6" stroke="currentColor" strokeWidth="2" />
                                )}
                            </svg>
                            <span className="hidden md:inline-block">{isPlaying ? 'ON' : 'OFF'}</span>
                        </button>
                        <button
                            onClick={nextTrack}
                            className="border-2 border-black px-2 py-1 shadow-[2px_2px_0_0_#000] hover:bg-black hover:text-acid active:translate-y-1 active:translate-x-1 active:shadow-none transition-none focus:outline-none"
                            title="Next Track"
                        >
                            {tracks[trackIndex].name}
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default Header; 